import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ContextService, CartService } from '../shared';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { environment } from '../../environments/environment';
import { DatePipe } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import {
  Article,
  ArticlesService,
  User,
  UserService
} from '../shared';

@Component({
  selector: 'article-page',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {
  article: any;
  typeArticle: any;
  niveauScolaire: Array<any> = [];
  discipline: Array<any> = [];
  publicCible: any;
  supportDistribution: any;
  editeur: any;
  offreCommerciale: any;
  articleConnexe: Array<any> = [];
  plateformeSupportee: Array<any> = [];
  technologieSupport: any;
  tauxTaxe: any;
  currentUser: User;
  userAuthed: boolean;
  creationDate: string;
  canModify: boolean;
  isSubmitting = false;
  isDeleting = false;
  imgfolder_url:string;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  isCollapsed: boolean = false;
  context: string;
  context_root: string='';
   loading: boolean = true;
 
  constructor(
    private route: ActivatedRoute,
    private articlesService: ArticlesService,
    private router: Router,
    private userService: UserService,
    private modalService: BsModalService,
    private contextService: ContextService,
    private cartService: CartService,
  ) { 
     window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.currentUser = this.userService.currentUserSubject.getValue();
    this.userAuthed = this.userService.isAuthenticatedSubject.getValue();
    this.imgfolder_url=environment.imgfolder_url;
    this.context = this.contextService.getContext();
    this.context_root = (this.context == 'B2B')?'':'/familles';


     this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
          let url =ev.url.split("/");
          let area = (url[1] && url[1]=='familles') ? 'B2C':'B2B';
          this.contextService.setContext(area);
          this.context_root=(this.contextService.getContext()=='B2B')?'':'/familles';
          this.context = area;
          window.scrollTo(0, 0);
          this.loading=true;
          this.getArticle()
 
        }
          
     });

   
     this.getArticle()


    // this.route.data.subscribe(
    //   (data: { article: Article }) => {
    //     console.log(data);
    //     this.article = data.article.article;
    //     this.typeArticle = data.article.typeArticle;
    //     this.niveauScolaire = data.article.niveauScolaire;
    //     this.discipline = data.article.discipline;
    //     this.publicCible = data.article.publicCible;
    //     this.supportDistribution = data.article.supportDistribution;
    //     this.editeur = data.article.editeur;
    //     this.offreCommerciale = data.article.offreCommerciale;
   

    //     for(let item of this.offreCommerciale){
    //         item.prixttc = item.tarifBaseFranceTTC;
    //         if(this.userAuthed){
    //           if(this.currentUser.idPaysLPC != 33){
    //             item.prixttc = item.tarifBaseExportTTC;
    //           }
    //         }
    //         item.quantite = item.quantiteMinimaleAchat;
    //     }
         
    //     this.articleConnexe = data.article.articleConnexe;
    //     this.plateformeSupportee = data.article.plateformeSupportee;
    //     this.technologieSupport = data.article.technologieSupport;
    //     this.tauxTaxe = data.article.tauxTaxe;et
    //     // this.creationDate = this.article.dateDisponibiliteReelle;
    //   }
    // );
    

  }

  

  getArticle(): void {
    // console.log(this.context)
    const slug = this.route.snapshot.paramMap.get('slug');
    let data;
    this.articlesService.get(slug, this.context)
      .subscribe(dat => {
        console.log(dat)
        data = dat;
      },
      error => {
        console.log(error)
      },
      () => {
        this.loading=false
        this.article = data.article;
        this.typeArticle = data.typeArticle;
        this.niveauScolaire = data.niveauScolaire;
        this.discipline = data.discipline;
        this.publicCible = data.publicCible;
        this.supportDistribution = data.supportDistribution;
        this.editeur = data.editeur;
        this.offreCommerciale = data.offreCommerciale;
   

        for(let item of this.offreCommerciale){
            item.prixttc = item.tarifBaseFranceTTC;
            if(this.userAuthed){
              if(this.currentUser.idPaysLPC != 33){
                item.prixttc = item.tarifBaseExportTTC;
              }
            }
            item.quantite = item.quantiteMinimaleAchat;
        }
         
        this.articleConnexe = data.articleConnexe;
        this.plateformeSupportee = data.plateformeSupportee;
        this.technologieSupport = data.technologieSupport;
        this.tauxTaxe = data.tauxTaxe;
      });
  }

  addToCart(item, template: TemplateRef<any>){
    
    if(this.context == 'B2C') item.quantite=1;
    this.userAuthed = this.userService.isAuthenticatedSubject.getValue();

    let body:any = {
      idOffreCommerciale: item.id,
      quantite: item.quantite,
    };

    

    // console.log(this.userAuthed)
    if(item.offre){
      body.indicateurAdoption = true;
    } else {
      if(item.typeAdoption.id == 2){
        body.indicateurAdoption = true;
      } else {
        body.indicateurAdoption = false;
      }
    }
    
    //
    if(this.userAuthed){
      body.idPaysLPC = this.currentUser.idPaysLPC;
    }

     if(this.userAuthed){

         this.cartService.postLineValidateSave(body)
            .subscribe(
              data => {
                // console.log(data);
                if(this.cartService.isEmptyLocalCart()){
                  this.cartService.setLocalCart(data);
                } else {
                  let ligne = data.lignePanier[0];
                  this.cartService.addLineToLocalCart(ligne, data.montantFraisDePort);
                }
                this.openModal2(template);
                this.cartService.cartevent.emit('cartchange');
            }, error =>{


                
                if(error[0].Code=='LIGNE_EXISTANTE'){
                   body.id=error[0].id;
                   this.cartService.putLineUpdate(body).subscribe(
                        data => {
                           this.openModal2(template);
                           this.cartService.cartevent.emit('cartchange');
                        }
                       );
                }else{
                    alert(error[0].Message)
                } 


               }
            );

     }else{
       body.marche = this.context;
          this.cartService.postLineValidate(body)
            .subscribe(
              data => {
                // console.log(data);
                if(this.cartService.isEmptyLocalCart()){
                  this.cartService.setLocalCart(data);
                } else {
                  let ligne = data.lignePanier[0];
                  this.cartService.addLineToLocalCart(ligne, data.montantFraisDePort);
                }
                this.cartService.cartevent.emit('cartchange');
                this.openModal2(template);
            }, error =>{
                alert('Désolé, une erreur est survenue')
               });
     }




   

  }

  checkPreorder(article, offres){
    if(article.dateDisponibiliteTheorique != null){
      if(article.dateDisponibiliteReelle != null){
        if(offres.length > 0){
          return 'par';
        }
      } else {
        if(offres.length > 0){
          return 'pre';
        }
      }
    } else {
      if(article.dateDisponibiliteReelle != null){
        if(offres.length > 0){
          return 'par';
        }
      }
    }
  }

  articleSupports(supports){
    let html = '';
    let results = [];
    let results_t = [];
    html += '<br>- Ordinateur : ';

    if(supports == null) return;
    for(let item of supports){
      if(item.id == 1 || item.id == 2 || item.id == 3){
        results.push(item.libelle);
      } else {
        results_t.push(item.libelle);
      }
    }

    if(results.length > 0){
      html += results.join(', ') + '<br>';
    } else {
      html += 'NON<br>';
    }

    html += '- Tablette : ';

    if(results_t.length > 0){
      html += results_t.join(', ');
    } else {
      html += 'NON';
    }

    return html;
  }

  isNew(creationDate){
    let date = new Date(creationDate);
    let now = new Date();

    if(this.diff_months(date, now) <= 1){
      return true;
    } else {
      return false;
    }
  }

  diff_months(dt2, dt1) 
  {

    let diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= (60 * 60 * 24 * 30);
    return Math.abs(Math.round(diff));
  
  }

  onChange(check, item, tarifs){
    let available_tarifs = tarifs.filter( t => t.quantiteSeuilTarif <= item.quantite );
    available_tarifs.sort( function(a, b){
      let keyA = a.quantiteSeuilTarif;
      let keyB = b.quantiteSeuilTarif;
      if (keyA < keyB) return 1;
      if (keyB > keyA) return -1;
      return 0;
    });

    let offre = available_tarifs[0];
    if(check) {
      item.prixttc = offre.prixUnitaireFranceTTC;
      if(this.userAuthed){
        if(this.currentUser.idPaysLPC != 33){
          item.prixttc = offre.prixUnitaireExportTTC;
        }
      }
      item.offre = offre.id;
    }else{
      item.prixttc = item.tarifBaseFranceTTC;
      if(this.userAuthed){
        if(this.currentUser.idPaysLPC != 33){
          item.prixttc = item.tarifBaseExportTTC;
        }
      }
      item.offre = "";
    }
    
  }

  onQuantiteChange(item){
    if(item.quantite < item.quantiteMinimaleAchat){
      item.quantite = item.quantiteMinimaleAchat;
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  openModal2(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(template);
  }

  hideModal(){
    this.modalRef2.hide();
  }

  collapsed(event: any): void {
    console.log(event);
  }
 
  expanded(event: any): void {
    console.log(event);
  }

  truncate(value: string, limit: number = 40, trail: String = '…'): string {
    let result = value || '';

    if (value) {
      const words = value.split(/\s+/);
      if (words.length > Math.abs(limit)) {
        if (limit < 0) {
          limit *= -1;
          result = trail + words.slice(words.length - limit, words.length).join(' ');
        } else {
          result = words.slice(0, limit).join(' ') + trail;
        }
      }
    }

    return result;
  }



}



// WEBPACK FOOTER //
// ./src/app/article/article.component.ts